import { render, staticRenderFns } from "./FormRecommendation.vue?vue&type=template&id=004f805a&scoped=true"
import script from "./FormRecommendation.vue?vue&type=script&lang=ts"
export * from "./FormRecommendation.vue?vue&type=script&lang=ts"
import style0 from "./FormRecommendation.vue?vue&type=style&index=0&id=004f805a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f805a",
  null
  
)

export default component.exports